import Icon from '@ant-design/icons';

const QuoteSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon/16/Quote">
        <path
          id="Vector"
          d="M3.54453 11.1701C2.92638 10.5139 2.59448 9.77743 2.59448 8.58361C2.59448 6.48395 4.06839 4.60163 6.21284 3.67134L6.74845 4.49791C4.74731 5.58067 4.35619 6.98503 4.19987 7.87063C4.52206 7.70401 4.94383 7.64539 5.35731 7.68373C6.43993 7.78411 7.2932 8.67283 7.2932 9.77743C7.2932 10.9372 6.35298 11.8774 5.19318 11.8774C4.54934 11.8774 3.93366 11.5831 3.54453 11.1701ZM9.54452 11.1701C8.9264 10.5139 8.59448 9.77743 8.59448 8.58361C8.59448 6.48395 10.0684 4.60163 12.2128 3.67134L12.7485 4.49791C10.7473 5.58067 10.3562 6.98503 10.1998 7.87063C10.522 7.70401 10.9438 7.64539 11.3573 7.68373C12.4399 7.78411 13.2932 8.67283 13.2932 9.77743C13.2932 10.9372 12.353 11.8774 11.1932 11.8774C10.5493 11.8774 9.93368 11.5831 9.54452 11.1701Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const QuoteIcon = (props: any) => <Icon component={QuoteSvg} {...props} />;
